import { Component, computed, inject, input } from '@angular/core';
import { NodeHome } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { MediaComponent } from '@app/components/media/media.component';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';
import { MobiLdSchemaComponent } from '@app/components/mobi-ld-schema/mobi-ld-schema.component';
import { PlatformContextService } from '@app/services/platform-context.service';

@Component({
  selector: 'mobi-node-home',
  templateUrl: './node-home.component.html',
  styleUrls: ['./node-home.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    MediaComponent,
    MobiUiIconComponent,
    ParagraphLoaderComponent,
    MobiLdSchemaComponent,
  ],
})
export class NodeHomeComponent {
  readonly entity = input.required<NodeHome>();
  #platformContext = inject(PlatformContextService);

  readonly protektaOrganizationSchema = computed<Record<string, unknown> | null>(() => {
    if (!this.#platformContext.isProtekta()) {
      return null;
    }

    const language = (this.entity().language || 'de').slice(0, 2) as 'de' | 'fr' | 'it';

    const localized = {
      de: {
        url: 'https://protekta.mobiliar.ch',
        sameAs:
          'https://www.mobiliar.ch/ueber-uns/die-mobiliar/unternehmen-der-gruppe/protekta',
        legalName: 'Protekta Rechtsschutzversicherung AG',
        description:
          'Die Protekta Rechtsschutzversicherung ist bei rechtlichen Streitigkeiten an Ihrer Seite: Finanzielle Übernahme von Anwalts- und Gerichtskosten sowie rechtliche Unterstützung durch Jurist:innen. Protekta ist eine Tochterfirma der Mobiliar mit Sitz in Bern.',
      },
      fr: {
        url: 'https://protekta.mobiliere.ch',
        sameAs:
          'https://www.mobiliere.ch/a-propos/la-mobiliere/entreprises-du-groupe/protekta',
        legalName: 'Protekta Assurance de protection juridique SA',
        description:
          'Protekta est à vos côtés en cas de litige: prise en charge financière des frais d’avocat et de justice et assistance juridique par des juristes. Protekta est une filiale de la Mobilière.',
      },
      it: {
        url: 'https://protekta.mobiliare.ch',
        sameAs:
          'https://www.mobiliare.ch/chi-siamo/la-mobiliare/societa-del-gruppo/protekta',
        legalName: 'Protekta Assicurazione di protezione giuridica SA',
        description:
          "Al suo fianco, in caso di controversie giuridiche: copertura finanziaria delle spese per l’avvocato e il tribunale nonché sostegno legale da parte dei giuristi della Jurline. La Protekta è un'affiliata della Mobiliare.",
      },
    };

    const content = localized[language] || localized.de;

    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Protekta',
      url: content.url,
      sameAs: content.sameAs,
      logo: `${content.url}/logos/protekta.svg`,
      contactPoint: {
        contactType: 'Customer Service',
        email: 'info@protekta.ch',
        telephone: '+41313898500',
      },
      address: [
        {
          '@type': 'PostalAddress',
          streetAddress: 'Monbijoustrasse 5',
          addressLocality: 'Bern',
          postalCode: '3011',
          addressCountry: 'CH',
        },
      ],
      legalName: content.legalName,
      description: content.description,
    };
  });
}
